












































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import {
  getArticles,
  addEquipment,
  editForm,
  getinfo,
} from "@/api/guideManage";
import Pagination from "@/components/Pagination/index.vue";
import draggable from "vuedraggable";
@Component({
  name: "guideManage",
  components: { Pagination, draggable },
})
export default class extends Vue {
  [x: string]: any;
  // [x: string]: any;
  mounted() {
    this.getList(this.listQuery);
  }
  private currtentpage = 1;
  private total: number = 0;
  private diatitle = "";
  private formObj = {
    dialogVisible: false,
  };
  private tableData = [];
  private currentPage: number = 1;
  private value: boolean = true;
  private isloading = true;
  private isuse = 1;

  private addParams: any = {
    descri: "",
    content: "",
    updatetime: new Date(),
    isuse: 1,
    itemBeanList: [
      {
        content: "",
        num: "",
      },
    ],
  };
  private editparms: any = {};
  private listQuery = {
    content: "",
    page: 1,
    limit: 10,
    isuse: 2,
  };
  // 表单校验规则
  private rules = {
    name: [
      { required: true, message: "请输入指南名称", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    description: [
      { required: true, message: "请输入备注内容", trigger: "blur" },
      // { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
    ],
    number: [{ required: true, message: "请输入指南编号", trigger: "change" }],
  };

  // 获取列表
  private async getList(params: any) {
    await getArticles(params)
      .then((res) => {
        if (res.code === 200) {
          console.log(res);
          this.isloading = false;
          this.tableData = res.data.itemBeanList[0];
          console.log(this.tableData);
          this.total = res.data.total;
        }
      })
      .catch(() => {
        // this.list = [];
        // this.listLoading = false;
      });
  }
  private onStart() {}
  private onEnd() {}
  private async changeSwitch(parms: any) {
    const usestate = parms.isuse === true ? 1 : 0;
    const param = {
      id: parms.id,
    };
    await getinfo(param).then(async (res) => {
      if (res.code === 200) {
        this.editparms = res.data;
        this.editparms.isuse = usestate;
        this.editparms.isdelete = 1;
        await editForm(this.editparms).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              message: "状态更改成功",
              type: "success",
            });
            this.editparms = {};
          } else {
            this.$message({
              message: "状态更改失败",
              type: "warning",
            });
          }
        });
      }
    });
  }
  private async changswitch(row: any, isuse) {
    let param = {
      id: row.id,
    };
    getinfo(param).then(async (res) => {
      if (res.code === 200) {
        let up_param = res.data;
        up_param.isuse = isuse;
        await editForm(up_param).then((res: any) => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "状态更改成功!",
            });
            this.getList(this.listQuery);
            this.editparms = {
              name: "",
              description: "",
              isuse: "",
              id: "",
              isdelete: 1,
            };
          } else {
            this.$message({
              message: "状态更改失败",
              type: "warning",
            });
          }
        });
      }
    });
  }
  private async deletedata(params: any) {
    let param = {
      id: params.id,
    };
    getinfo(param).then((res) => {
      if (res.code === 200) {
        let up_param = res.data;
        up_param.isdelete = 1;
        this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          await editForm(up_param).then((res: any) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getList(this.listQuery);
              this.editparms = {
                name: "",
                description: "",
                isuse: "",
                id: "",
                isdelete: 1,
              };
            } else {
              this.$message({
                message: "删除失败",
                type: "warning",
              });
            }
          });
        });
      }
    });
  }
  private onSubmit() {
    this.getList(this.listQuery);
  }
  private reduceTime(index) {
    if (this.addParams.itemBeanList.length === 1) {
      this.$message({
        type: "warning",
        message: "最少需要添加一条课题方向",
      });
    } else {
      this.addParams.itemBeanList.splice(index, 1);
    }
  }
  private addTime() {
    this.addParams.itemBeanList.splice(this.addParams.itemBeanList.length, 0, {
      content: "",
    });
  }
  private clearSearch() {
    this.listQuery.content = "";
    this.getList(this.listQuery);
  }
  private onCreatItem() {
    this.isuse = 1;
    this.diatitle = "新建指南";
    this.addParams = {
      descri: "",
      content: "",
      isuse: 1,
      itemBeanList: [
        {
          content: "",
          num: "",
        },
      ],
    };
    this.formObj.dialogVisible = true;
    this.$nextTick(() => {
      (this.$refs.addParams as any).resetFields();
    });
  }

  private async editItem(params: any) {
    const parm = { id: params };
    this.diatitle = "编辑指南";
    await getinfo(parm).then((res: any) => {
      if (res.code === 200) {
        this.isloading = false;
        this.addParams = res.data;
        this.isuse = res.data.isuse;
        this.editparms = res.data;
      }
    });
    this.formObj.dialogVisible = true;
  }

  private handleClose(done: any) {
    this.formObj.dialogVisible = false;
    this.addParams = {
      descri: "",
      content: "",
      isuse: 1,
      itemBeanList: [
        {
          content: "",
          num: "",
        },
      ],
    };
  }

  private async subMitData(isuse) {
    this.$forceUpdate();
    const form = this.$refs.addParams as any;
    form.validate(async (valid: boolean) => {
      if (valid) {
        if (this.editparms.id) {
          this.editparms.isdelete = 0;
          this.editparms.isuse = isuse;

          if (isuse == 1) {
            this.$confirm(
              "当前指南为生效状态，点击确定将导致其他指南的状态为失效，是否继续？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(async () => {
              this.editparms.itemBeanList.forEach((res, index) => {
                res.num = index + 1;
              });
              await editForm(this.editparms).then((res) => {
                if (res.code === 200) {
                  this.formObj.dialogVisible = false;
                  form.resetFields();
                  this.$message.success("修改成功");
                  this.getList(this.listQuery);
                }
              });
            });
          } else {
            await editForm(this.editparms).then((res) => {
              if (res.code === 200) {
                this.formObj.dialogVisible = false;
                form.resetFields();
                this.$message.success("修改成功");
                this.getList(this.listQuery);
              }
            });
          }
        } else {
          this.addParams.itemBeanList.forEach((res, index) => {
            res.num = index + 1;
          });
          if (isuse == 1) {
            this.$confirm(
              "该指南选择的状态为生效，点击确定后，系统会将其他指南设置为“未生效”状态，是否确定保存？",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(async () => {
              await addEquipment(this.addParams).then((res) => {
                if (res.code === 200) {
                  this.formObj.dialogVisible = false;
                  form.resetFields();
                  this.$message.success("添加成功");
                  this.getList(this.listQuery);
                }
              });
            });
          } else {
            console.log(this.addParams);
            await addEquipment(this.addParams).then((res) => {
              if (res.code === 200) {
                this.formObj.dialogVisible = false;
                form.resetFields();
                this.$message.success("添加成功");
                this.getList(this.listQuery);
              }
            });
          }
        }
      } else {
        return false;
      }
    });
  }
  // 分页
  private handleSizeChange(val: number) {
    this.listQuery.limit = val;
    this.getList(this.listQuery);
  }
  private handleCurrentChange(val: number) {
    this.listQuery.page = val;
    this.getList(this.listQuery);
  }
  private cellStyle({
    row,
    column,
    rowIndex,
    columnIndex,
  }: {
    row: any;
    column: any;
    rowIndex: any;
    columnIndex: any;
  }) {
    return "text-align:center";
  }
  private rowClass({ row, rowIndex }: { row: any; rowIndex: any }) {
    return "text-align:center";
  }
}
